import React from 'react';
import styles from './curd.module.scss';
import { KoFormBuilder, KoNumber, KoSelect } from 'packages';
export default function Pricing({form, product}) {
 

  const Currency = ({ value, onChange }) =>
    <KoSelect
      placeholder="Select module"
      value={value}
      onChange={v => onChange(v)}
      options={[{
        name:'USD', value:'usd'
      }].map((module) => ({
        label: module?.name,
        value: module?.value
      }))}
    />;

  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: product,
    colon: true,
    fields: [
      {
        key: 'currency', label: 'Currency', colSpan: 1, widget: Currency,
        rules: [
          {
            required: true,
            message: 'Currency is required'
          }
        ]
      },
      {
        key: 'amount', label: 'Amount', colSpan: 3, widget: KoNumber,
        rules: [
          {
            required: true,
            message: 'Amount is required'
          }
        ]
      },
      {
        key: 'label1',
        colSpan: 4,
        render() {
          return (
            <fieldset>
              <legend></legend>
            </fieldset>
          );
        }
      },
      {
        key: 'discount', label: 'Discount Type', colSpan: 1, widget: Currency
      },
      {
        key: 'tax', label: 'Tax Class', colSpan: 1, widget: Currency
      }
    ]
  };
 
  return (
    <div className={styles.wrapper}>
      <KoFormBuilder form={form} meta={meta} />
    </div>
  );
}
